/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Automatic_Translation_TitleInputs */



/**
* | output |
* | --- |
* | "Automatic Translation" |
*
* @param {Toolbar_Secondary_Automatic_Translation_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_automatic_translation_title = /** @type {((inputs?: Toolbar_Secondary_Automatic_Translation_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Automatic_Translation_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traduction Automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Übersetzung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Traduzione automatica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматический перевод")
	if (locale === "es") return /** @type {LocalizedString} */ ("Traducción automática")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动翻译")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動翻訳")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित अनुवाद")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tradução automática")
	return /** @type {LocalizedString} */ ("Automatic Translation")
});